/**
 * Clamped detail text for structure-map entity cards.
 *
 * Purpose: the corporate agent accumulates multi-sentence narrative in an
 * entry's `detail` field over the life of a job (each new document appends
 * facts), so rendering it raw produces a wall of text on every card. Short
 * details render as-is; long ones are clamped to two lines with a
 * Show more / Show less toggle.
 */

import { useState } from "react";
import { cn } from "@/utils/misc";

/** Details longer than this get clamped with an expand toggle. */
const DETAIL_CLAMP_THRESHOLD = 160;

export function EntityDetailText({ detail }: { detail: string }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const isLong = detail.length > DETAIL_CLAMP_THRESHOLD;

  if (!isLong) {
    return (
      <p className="mt-1 text-xs leading-relaxed text-muted-foreground">
        {detail}
      </p>
    );
  }

  return (
    <div className="mt-1">
      <p
        className={cn(
          "text-xs leading-relaxed text-muted-foreground",
          !isExpanded && "line-clamp-2",
        )}
      >
        {detail}
      </p>
      <button
        type="button"
        onClick={() => setIsExpanded((v) => !v)}
        className="mt-0.5 cursor-pointer text-[11px] font-medium text-primary hover:underline"
      >
        {isExpanded ? "Show less" : "Show more"}
      </button>
    </div>
  );
}
